export enum LinkTypeEnum {
  SUBSCRIPTION_LINK = 'subscriptionLink',
  PROGRAM_LINK = 'programLink',
  COMMERCIAL_LINK= 'commercialLink'
}
